export const en = {
  common: {
    appName: "Miaparle",
    home: "Home",
    continue: "Continue",
    save: "Save",
    next: "Next →",
    clickToStart: "Click here to start",
    goodJob: "Good job!",
    notQuite: "Not quite!",
    tryAgain: "Try again",
    exerciseComplete: "Exercise complete!",
    bestScore: (score: string | number, max: string | number) =>
      `Best: ${score}/${max}`,
    newBestScore: "New best score!",
    wordProgress: (current: number, total: number) =>
      `Word ${current} of ${total}`,
    closeHelp: "Close help",
    firefoxWarning:
      "It looks like you are using Firefox. For the best experience, we recommend using Chrome, Edge, or Safari, as some features may not work as expected in Firefox.",
    scoreFeedbackFantastic: (score: number, max: number) =>
      `Your score: ${score}/${max}. Fantastic!`,
    scoreFeedbackGreat: (score: number, max: number) =>
      `Your score: ${score}/${max}. Great job!`,
    scoreFeedbackWellDone: (score: number, max: number) =>
      `Your score: ${score}/${max}. Well done!`,
    scoreFeedbackCanDoBetter: (score: number, max: number) =>
      `Your score: ${score}/${max}. You can do better!`,
  },
  home: {
    welcome: (name: string) => `Welcome, ${name}!`,
    letsSpeakTitle: "Let's speak!",
    tuneYourEarTitle: "Let's tune your ear!",
    challengeYourEarTitle: "Let's challenge your ear!",
    progress: (current: number, total: number) =>
      `Progress ${current}/${total}`,
    score: (score: string | number, total: number) => `Score ${score}/${total}`,
    summaryLink: "See your summary →",
  },
  summary: {
    title: "Great job!",
    message:
      "You have finished all the exercises\n\nYou can do them again to practice more!",
    speak: "Let's speak!",
    tune: "Let's tune your ear!",
    challenge: "Let's challenge your ear!",
  },
  onboarding: {
    welcome: "Welcome!",
    yourName: "Your name",
    enterYourName: "Enter your name",
    nameReserved: "This name is reserved, please choose another",
    allowRecordings: "Allow recordings to be saved for research",
    firefoxAck: "I understand and want to continue anyway",
    firefoxAckRequired: "Please acknowledge the Firefox warning",
  },
  notFound: {
    title: "Page not found",
    description: "This page does not exist.",
  },
  settings: {
    title: "Settings",
    successSound: "Play success sound",
    resetDescription: "Reset all progress and settings",
    resetButton: "Reset app",
  },
  prod: {
    title: "Let's speak!",
    instruction: "Say the word aloud",
    playWord: "▷ Play word",
    playWordLabel: "Play word",
    showHintsLabel: "Show hints",
    hideHintsLabel: "Hide hints",
    turnToHints: "Turn card to hints",
    turnToImage: "Turn card to image",
    playMyAttempt: "Play my attempt",
    starting: "Starting...",
    recording: "Listening...",
    analyzing: "Analyzing",
    speak: "Speak",
    listenToWordAndTryAgain: "Not quite! Listen to the word and try again!",
    checkHintsAndTryAgain: "Not quite! Check the hints and try again!",
    youllDoBetterNext: "Not quite! You'll do better next!",
    nextWord: "Next word →",
    skipPrompt:
      "Something went wrong multiple times in a row. Would you like to skip the exercise?",
    skipExercise: "Skip exercise",
    keepTrying: "Keep trying",
    tuneYourEarPrompt: "Let's tune your ear to improve your pronunciation!",
    tuneYourEarLink: "Let's tune your ear! →",
    speakAgain: "Speak again",
    consentTitle:
      "Do you allow us to use your voice recordings to improve our app?",
    consentSubtitle: "You can always change it in settings",
    consentYes: "Yes",
    consentNo: "No",
    help: {
      step1: "Click Speak and say the word. Recording stops automatically",
      step2: "Click 'Play word' to hear the word",
      step3: "Click 'Show hints' to get information about the word",
    },
  },
  train: {
    title: "Let's tune your ear!",
    instruction:
      "Which shape corresponds to the stress pattern of the word you hear?",
    clickShapeToAnswer: "Click on a shape to answer",
    replayWord: "▷ Replay word",
    playing: "Playing ...",
    nextWord: "Next word →",
    challengeYourEarLink: "Let's challenge your ear! →",
    help: {
      step1: "Click 'Replay word' to hear the word again, if needed",
      step2: "Click on the shape that matches the stress pattern you hear",
      step3: "Each shape shows a different stress pattern",
    },
  },
  omo: {
    title: "Let's challenge your ear!",
    instruction: "Which word is stressed differently?",
    clickNumberToAnswer: "Click on 1, 2, or 3 to answer",
    replayWords: "▷ Replay words",
    playing: "Playing ...",
    nextWord: "Next word →",
    challengeAgain: "Let's challenge your ear again!",
    help: {
      step1: "Click 'Replay words' to hear 3 words again, if needed",
      step2:
        "Click on 1, 2, or 3 to select the word that is stressed differently",
    },
  },
  errors: {
    allowMicrophone: "Allow microphone",
    couldNotProcessAudio: "Could not process audio. Try recording again",
    couldNotAnalyzeSpeech:
      "Could not analyze speech. Try speaking more clearly",
    recordingFailed: "Recording failed. Please try again",
    somethingWentWrong: "Something went wrong. Please try again",
    microphoneInstructions:
      "To enable: click the ⋮ menu → Settings → Site settings → Microphone → find\nthis site → Allow",
  },
} as const;
